import SwitchFormField from 'components/molecules/SwitchFormField/SwitchFormField';
import { ModalTypes } from 'enums/modalTypes';
import { openModal } from 'graphql/modals';
import { FC } from 'react';
import { Button } from '@mui/material';
import styles from './TraitsHeader.module.scss';

interface ITraitsHeader {
  isArchivedVisible: boolean;
  setIsArchivedVisible: (isArchivedVisible: boolean) => void;
}

const TraitsHeader: FC<ITraitsHeader> = ({
  isArchivedVisible,
  setIsArchivedVisible,
}) => {
  const toggleArchivedProjectsVisibility = () => {
    setIsArchivedVisible(!isArchivedVisible);
  };

  const handleOpenAddTraitsModal = () => {
    openModal(ModalTypes.ADD_TRAIT_MODAL, {});
  };

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div>
          <SwitchFormField
            id="toggle-displey-archived-traits"
            name="isArchivedVisible"
            color="primary"
            value={isArchivedVisible}
            label="hide / display archived traits"
            onChange={toggleArchivedProjectsVisibility}
          />
        </div>
        <div>
          <Button
            onClick={handleOpenAddTraitsModal}
            className={styles.button}
            variant="contained"
            color="inherit"
          >
            Add new
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TraitsHeader;
